'use client';

import { useI18n } from '@/i18n/context';
import { localeNames, type Locale } from '@/i18n/config';
import { cn } from '@/lib/utils';

export function LanguageSwitcher({ className, variant = 'light' }: { className?: string; variant?: 'light' | 'dark' }) {
  const { locale, setLocale } = useI18n();

  const isDark = variant === 'dark';

  const handleClick = (lang: Locale) => {
    if (lang !== locale) {
      setLocale(lang);
    }
  };

  const baseBtn = cn(
    'text-[11px] tracking-[0.22em] font-medium transition-colors duration-300 uppercase',
    isDark ? 'text-[color:var(--mp-cream)]/60 hover:text-[color:var(--mp-cream)]' : 'text-[color:var(--mp-stone)] hover:text-[color:var(--mp-forest)]'
  );
  const activeBtn = isDark
    ? '!text-[color:var(--mp-cream)]'
    : '!text-[color:var(--mp-forest)]';

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {(['zh', 'en'] as Locale[]).map((lang, i) => (
        <span key={lang} className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => handleClick(lang)}
            className={cn(baseBtn, locale === lang && activeBtn)}
            aria-pressed={locale === lang}
          >
            {localeNames[lang]}
          </button>
          {i === 0 && (
            <span
              className={cn(
                'h-3 w-px',
                isDark ? 'bg-[color:var(--mp-cream)]/25' : 'bg-[color:var(--mp-stone)]/50'
              )}
            />
          )}
        </span>
      ))}
    </div>
  );
}
